<template>
  <div class="layout-center-wrap">
    <!-- 회원가입 상단 헤더 -->
    <header class="member_pg_tit__wrap">
      <h1 id="signup-title" class="member_pg_tit" v-if="type === 'ID'">
        아이디 찾기
      </h1>
      <h1
        id="signup-title"
        class="member_pg_tit"
        v-else-if="type === 'PASSWORD'"
      >
        비밀번호 찾기
      </h1>
      <h1
        id="signup-title"
        class="member_pg_tit"
        v-else-if="type === 'NONMEMBER'"
      >
        비회원 신고
      </h1>
    </header>
    <!-- 본인인증 -->
    <table
      v-if="type === 'PASSWORD'"
      class="action_card__wrap form-table type-block--mobile"
    >
      <tbody>
        <tr>
          <th scope="row" class="th--blue">아이디</th>
          <td>
            <div class="layout-flex-row">
              <label for="userId" class="sr-only">아이디 입력</label>
              <input
                type="text"
                id="userId"
                class="form-table__input"
                v-model="userId"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <section class="action_card__wrap">
      <article
        class="action_card"
        role="region"
        aria-labelledby="phone-title"
        aria-describedby="minor-desc"
      >
        <h2 class="action_card__title">휴대폰 인증</h2>
        <div class="action_card__icon" aria-hidden="true">
          <img src="@/assets/img/icon_reporter.png" alt="" class="light-only" />
          <img
            src="@/assets/img/icon_reporter_white.png"
            alt=""
            class="dark-only"
          />
        </div>
        <p id="signup-desc" class="action_card__desc" v-if="type === 'ID'">
          아이디를 찾기 위해 휴대폰 인증이 필요합니다.
          <br />본인인증 시 사용한 이름과 전화번호를 통해 아이디를 확인할 수
          있습니다.
        </p>
        <p
          id="signup-desc"
          class="action_card__desc"
          v-else-if="type === 'PASSWORD'"
        >
          비밀번호를 찾기 위해 휴대폰 인증이 필요합니다.
          <br />가입하신 아이디와 본인인증 시 사용한 이름과 전화번호를 통해
          비밀번호를 변경할 수 있습니다.
        </p>
        <p
          id="signup-desc"
          class="action_card__desc"
          v-else-if="type === 'NONMEMBER'"
        >
          본인인증 후 비회원으로 취약점 신고를 진행할 수 있습니다.
          <br />비회원으로 취약점을 신고하실 경우 신고포상제 평가 및 평가대상
          <br />
          선정을 위한 추가 자료를 요청할수 있습니다.
        </p>
        <div class="action_card__actions">
          <NicePopup
            v-on:success="executeAfterAuth"
            :title="
              type === 'NONMEMBER' ? '신고자 본인인증' : '사용자 본인인증'
            "
            aria-describedby="signup-desc signup-desc"
          />
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { ref } from "vue";
import NicePopup from "./NicePopup.vue";
export default {
  components: {
    NicePopup,
  },
  props: {
    type: {
      type: String,
      default: "ID",
    },
  },
  emits: ["success"],
  setup(props, { emit }) {
    const router = useRouter();

    // data 정의
    const userId = ref(null);

    // methods 정의
    const executeAfterAuth = (refId) => {
      emit("success", refId, userId.value);
    };

    // html에서 사용될 데이터 정의
    return { executeAfterAuth, userId };
  },
};
</script>
